// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30CX0","col":"styles_col__1_FHD","actions":"styles_actions__16M5V","conflict":"styles_conflict__2tXtv"};